import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-applicationsrejected',
  templateUrl: './applicationsrejected.component.html',
  styleUrls: ['./applicationsrejected.component.css']
})
export class ApplicationsrejectedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
